// api/users.js
// 管理者用のユーザー情報の操作用APIを実装する

import Api from './api_base'

export default {
  // POST /users ユーザ情報を登録する
  post: (user) => {
    return Api.post('/users', user)
  },
  // DELETE /users/{id} 指定したidのユーザ情報を削除する
  delete: (id) => {
    return Api.delete('/users/' + id)
  },
  // GET: /users 全ユーザーの情報を取得する
  get: () => {
    return Api.get('/users')
  },
  // PUT: /users/{id} ユーザのすべての情報を変更する
  put: (id, param) => {
    return Api.put('/users/' + id, param)
  },
  // PUT: /users/{id}/password ユーザーのパスワードを変更する
  putPassword: ({ id, currentPassword, newPassword }) => {
    return Api.put('/users/' + id + '/password', {
      current_password: currentPassword,
      new_password: newPassword
    })
  },
  // PUT: /users/{id}/user_name ユーザーのユーザ名を変更する
  putUserName: ({ id, newUserName }) => {
    return Api.put('/users/' + id + '/user_name', {
      new_user_name: newUserName
    })
  },
  // PUT: /users/{id}/fullname ユーザーの氏名を変更する
  putFullname: ({ id, newFullname, newKana }) => {
    return Api.put('/users/' + id + '/fullname', {
      new_fullname: newFullname,
      new_kana: newKana
    })
  },
  putMailAddress: ({ id, newMailAddress }) => {
    return Api.put('/users/' + id + '/mail_address', {
      new_mail_address: newMailAddress
    })
  },
  putStatus: ({ id, newStatus }) => {
    return Api.put('users/' + id + '/status', {
      new_status: newStatus
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js